import PlacePicker from '../PlacePicker'
import Field, { inputClass } from '../../common/Field'
import Affixed, { affixedInputClass } from '../../common/Affixed'
import { PH_DIALLING_CODE, toNational } from '../../../utils/phone'
import { useWizard } from '../../../context/WizardContext'
import { FIELDS } from '../../../utils/copy'

/**
 * Step 6 — where it lands, and who answers the phone there.
 *
 * The number is required and the name is not, and the asymmetry is the point.
 * `phoneNumber` is what the rider dials from the gate, so an order without it is an order
 * that cannot be delivered. The name is only ever *whose* order this is, and the ordinary
 * answer — the customer's own — is already on the account.
 *
 * So the box stays empty and means *me*. Asking somebody to type their own name to
 * receive their own order is a field that exists for the database.
 */
export default function DropoffStep() {
  const { state, errors, setField, setLocation } = useWizard()

  return (
    <div className="grid gap-4">
      <PlacePicker
        kind="dropoff"
        loc={state.dropoff}
        setLoc={(next) => setLocation('dropoff', next)}
        error={Boolean(errors.dropoff)}
        errorMessage={errors.dropoff}
      />

      <Field id="phoneNumber" label={FIELDS.yourPhone} error={errors.phoneNumber} required>
        <Affixed affix={PH_DIALLING_CODE} invalid={Boolean(errors.phoneNumber)} wide>
          <input
            id="phoneNumber"
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            placeholder="9171234567"
            value={state.phoneNumber}
            // Folded on the way in, so a number pasted from Messenger as `09171234567`
            // does not become `+63 09171234567`.
            onChange={(event) => setField('phoneNumber', toNational(event.target.value))}
            aria-invalid={Boolean(errors.phoneNumber)}
            aria-describedby={errors.phoneNumber ? 'phoneNumber-error' : undefined}
            className={affixedInputClass(errors.phoneNumber, true)}
          />
        </Affixed>
      </Field>

      <Field id="dropoffContactName" label={FIELDS.dropoffName} hint={FIELDS.dropoffNameHint}>
        <input
          id="dropoffContactName"
          type="text"
          maxLength={80}
          autoComplete="off"
          value={state.dropoffContactName}
          onChange={(event) => setField('dropoffContactName', event.target.value)}
          className={inputClass(false)}
        />
      </Field>
    </div>
  )
}
